import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useMemo } from "react";
import { useFlags } from "../../../../server/optimizely";
import { useLexicalContext } from "../lexical-context";
import { $isPollNode } from "../nodes/poll/helpers";
import { $findAllNodesOfType } from "./find-all-nodes-of-type";

export function usePolls(): boolean {
  const [editor] = useLexicalComposerContext();
  const { toChannel, channelName } = useLexicalContext();

  const {
    flags: { polls_enabled },
  } = useFlags("polls_enabled");

  const hasNodes = useMemo(() => {
    let present = false;

    editor.update(
      () => {
        present = $findAllNodesOfType($getRoot(), $isPollNode).length > 0;
      },
      { discrete: true },
    );

    return present;
  }, [editor]);

  if (channelName === "teams" && toChannel) return false;

  // Polls cannot be sent to teams channels, as we can't track the results.
  return polls_enabled || hasNodes;
}
